// extracted by mini-css-extract-plugin
module.exports = {"container":"_6eb00b8e53--container--11X97","work-time":"_6eb00b8e53--work-time--351Lh","phone":"_6eb00b8e53--phone--3zIxM"};